import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { TEXTAREA_VARIANTS } from "./constants";

export const textareaDataSchema = z.object({
  name: z.string().optional(),
  value: z.string().optional(),
  variant: z.enum(TEXTAREA_VARIANTS).optional(),
  size: z.enum(SIZES).optional(),
  placeholder: z.string().optional(),
  rows: z.coerce.number().int().positive().optional(),
  inputId: z
    .string()
    .optional()
    .describe(
      "Id forwarded to the inner <textarea> so an external <label for> can " +
        "focus it — not `id`, which stays on the host element for handle " +
        "lookups and would win the label association otherwise.",
    ),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  required: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type TextareaDataProps = z.infer<typeof textareaDataSchema>;
